import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { RadioButton } from 'ncoded-component-library';

import './RequestMethodOption.styles.scss';

type RequestMethodOptionProps = {
  className?: string;
  title: string;
  description: string;
  selected: boolean;
  onSelect: () => void;
};

const RequestMethodOption: React.FC<RequestMethodOptionProps> = (props) => {
  const { className, title, description, selected, onSelect } = props;

  const { t } = useTranslation();

  const classes = classNames('request-method-option', { selected }, className);

  return (
    <div className={classes} onClick={onSelect}>
      <RadioButton checked={selected} />
      <div>
        <p className="title">{t(title)}</p>
        <p className="description">{t(description)}</p>
      </div>
    </div>
  );
};

export default RequestMethodOption;
